import React from 'react'
import { Box, IconButton } from '@mui/material';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import AddCircleRoundedIcon from '@mui/icons-material/AddCircleRounded';
import { styled } from '@mui/material/styles';

const SocialLinkBox = styled(Box) ({
    border: "1px solid #D9D9D9",
    borderRadius: 4,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "4px"
  })

function SocialLinkItem({
    icon: Icon,
    label,
    network,
    contextState,
    onAdd
}) {

  const isLinkExists = contextState.links.find(link => link.network === network);

  return (
      <SocialLinkBox>
          <div className='d-flex align-items-center'>
              <div className="mx-2 flex-center">
                  <Icon className="icon-color3 social-icon svg-icon-32px" />
              </div>
              <div> {label} </div>
          </div>
          <IconButton color='#0000008A' onClick={() => !isLinkExists && onAdd(network)} disabled={isLinkExists} disableTouchRipple className='disabled-check-icon'>
              {isLinkExists ? <CheckCircleRoundedIcon className='disabled-check-icon'/> : <AddCircleRoundedIcon />}
          </IconButton>
      </SocialLinkBox>
  )
}

export default SocialLinkItem